var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Button } from 'components/Button';
import { useAlert } from 'components/alert/AlertStack';
import { React, useState } from 'libs/react';
import './StorePaymentBypass.scss';
const DEV_BYPASS_TOKEN = 'promo-test-100';
function activePaymentId(deal) {
    var _a, _b, _c, _d, _e;
    return ((_c = (_b = (_a = deal.payments) === null || _a === void 0 ? void 0 : _a.find((payment) => payment.status === 'ACTIVE' && payment.description === 'Upsell')) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : (_e = (_d = deal.payments) === null || _d === void 0 ? void 0 : _d.find((payment) => payment.status === 'ACTIVE')) === null || _e === void 0 ? void 0 : _e.id);
}
/**
 * Dev-only shortcut that completes the active payment without Stripe.
 * @component StorePaymentBypass
 * @since 1.0.0
 */
export function StorePaymentBypass(props) {
    const { deal, onSuccess } = props;
    const alert = useAlert();
    const [processing, setProcessing] = useState(false);
    const dealPaymentId = activePaymentId(deal);
    if (process.env.NODE_ENV !== 'development' || !dealPaymentId) {
        return null;
    }
    function onSimulate() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!dealPaymentId || processing) {
                return;
            }
            setProcessing(true);
            try {
                const res = yield fetch(process.env.API_URL_ROOT + '/stripe-bypass', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        dealPaymentId,
                        bypassToken: DEV_BYPASS_TOKEN
                    })
                });
                if (!res.ok) {
                    throw new Error('Bypass failed');
                }
                onSuccess();
            }
            catch (_a) {
                alert.present({
                    title: React.createElement("p", null, t('Unable to simulate payment.'))
                });
            }
            finally {
                setProcessing(false);
            }
        });
    }
    return (React.createElement("div", { className: "store-payment-bypass" },
        React.createElement("p", { className: "store-payment-bypass__hint" }, t('Development only — skip Stripe and complete this payment.')),
        React.createElement(Button, { style: "outline", size: "small", picto: "bolt", label: t('Simulate payment'), processing: processing, disabled: processing, onPress: onSimulate })));
}
